import React, {useEffect, useState, Fragment} from 'react';
import RNUFormService from "../../../../services/RNUFormService";
import NumberFormat from "react-number-format";
import Color from "color";


const Template1BRisque = (props) => {
    const rnuFormService = new RNUFormService()
    const [items, setItems]= useState([])
    const fetchData = rnuFormService.getData('risque')
    const [asSurface, setAsSurface] = useState()

    useEffect(()=>{
        (fetchData)?setItems(fetchData):null;
        (props.formtype === 'level2' ||  props.formtype === 'level1')?setAsSurface(true):setAsSurface(null);
    },[fetchData])


    const renderItem=(item, index)=>{
        (typeof item.data_doc == 'string')?JSON.parse(item.data_doc):item.data_doc;
        const dataDoc = (typeof item.data_doc == 'string')?JSON.parse(item.data_doc):item.data_doc;
        return(
            <tr key={index}>
                    <td colSpan={2} className={'text-left'} style={{"padding": "0px", "paddingTop": "0.2cm"}}>
                                <div className={"ue-data-libelle1"}> {item.libelle_1}</div>
                                <div className={(asSurface)?'ue-data-description':'ue-data-long-description'} style={{"whiteSpace": "pre-warp"}}>{item.libelle_2}</div>
                { (dataDoc)?
                    <table className={"ue-table-small"}>
                        <tbody>
                        {
                            dataDoc.map((e, i) => {
                                return (renderSubItem(e, i))
                            })
                        }
                        </tbody>
                    </table>
                    :null
                }
                 </td>
                </tr>
    );
    }

    const renderSubItem = (item,index)=>{
        return (
            <tr key={index} >
                <td className={'text-left'} style={{'paddingLeft': '0cm'}}>
                    {
                        <span className={'ue-data-libelle2'}>{item.libelle_2}</span>
                    }
                </td>
                {
                     (asSurface)?
                        <Fragment>
                        <td className={'ue-col-surface'}>
                            <span><NumberFormat value={Math.round(item.surface)} displayType={'text'}
                                                thousandSeparator={' '}/>m<sup>2</sup> </span>
                        </td>
                        <td className={'ue-col-percent'}>
                            <span>({Math.round(item.pourcentage * 10) / 10}%)</span>
                        </td>
                        </Fragment>
                    :null
                }
            </tr>
        )
    }

    return (
        <div className="ue-section">
            <div className="ue-section ue-section-title" style={(props.primColor)?{"backgroundColor": Color(props.primColor).alpha(0.5)}:{}}>
                <span >RISQUES NATURELS ET TECHNOLOGIQUES</span>
            </div>
            <br/>
                <table className={"ue-table-simple ue-mb-3"}>
                    <thead>
                    <tr className={"ue-table-row-header"}>
                        <th>Description</th>
                        {
                            (props.formtype === 'level2' ||  props.formtype === 'level1')?
                                <th className={"text-right"}>Surface</th>
                                :<th className={"text-right"}></th>
                        }
                    </tr>
                    </thead>
                    <tbody>
                    {   (Object.values(items).length>0)?
                        Object.values(items).map((item, index) => {
                            (!item.description)?item.description='':null;
                            return (renderItem(item, index))
                        })
                        :<tr className={"text-center ue-row-no-data"}><td colSpan={2}>Pas de  donnée pour cette section</td></tr>
                    }
                    </tbody>
                </table>
        </div>
    );
};

export default Template1BRisque;
